import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'

import { ActiveUpload, UploadOrchestratorService } from '../file-uploader/upload-orchestrator.service'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'upload-progress-overlay',
  templateUrl: './upload-progress-overlay.component.html',
  styleUrls: ['./upload-progress-overlay.component.scss']
})
export class UploadProgressOverlayComponent implements OnInit, OnDestroy {
  uploads: ActiveUpload[] = []
  collapsed = false
  private sub?: Subscription

  constructor(private readonly uploadOrchestrator: UploadOrchestratorService) {}

  ngOnInit() {
    this.sub = this.uploadOrchestrator.getActiveUploads$().subscribe(items => {
      this.uploads = items
    })
  }

  ngOnDestroy() {
    this.sub?.unsubscribe()
  }

  get hasTerminalEntries(): boolean {
    return this.uploads.some(u => u.phase === 'done' || u.phase === 'error')
  }

  get allTerminal(): boolean {
    return this.uploads.length > 0 && this.uploads.every(u => u.phase === 'done' || u.phase === 'error')
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed
  }

  dismiss(id: string) {
    this.uploadOrchestrator.dismissUpload(id)
  }

  dismissAll(event: MouseEvent) {
    event.stopPropagation()
    this.uploadOrchestrator.dismissAll()
  }

  trackById(_idx: number, item: ActiveUpload) {
    return item.id
  }
}
